module.exports = {
          srcSet: "/_next/static/images/sat-logo-360-1380ad483e015fcccab94bc9831587f4.png"+" 360w"+","+"/_next/static/images/sat-logo-800-ea2fb119ee9c6576b8fe0a4ffe7db021.png"+" 800w",
          images:[ {path: "/_next/static/images/sat-logo-360-1380ad483e015fcccab94bc9831587f4.png",width: 360,height: 105},{path: "/_next/static/images/sat-logo-800-ea2fb119ee9c6576b8fe0a4ffe7db021.png",width: 800,height: 234}],
          src: "/_next/static/images/sat-logo-360-1380ad483e015fcccab94bc9831587f4.png",
          toString:function(){return "/_next/static/images/sat-logo-360-1380ad483e015fcccab94bc9831587f4.png"},
          
          width: 360,
          height: 105
        }